import { MEMBERS, IMPLICIT_GENDER } from "../wizardUtils";
import PersonalFieldsSection from "./PersonalFieldsSection";
import MedicalSection from "./MedicalSection";
import LifestyleSection from "./LifestyleSection";

export default function InsuredCard({ mKey, idx, ins, errors, setIns }) {
  const label = MEMBERS.find((m) => m.key === mKey)?.label || mKey;
  const implicit = IMPLICIT_GENDER[mKey];

  return (
    <div
      className="bg-surface border border-subtle rounded-2xl p-5 sm:p-6"
      data-testid={`insured-block-${mKey}`}
    >
      <div className="flex items-baseline justify-between mb-5">
        <div>
          <p className="text-xs uppercase tracking-widest text-muted-brand mb-1">
            Insured {idx + 1}
          </p>
          <h3 className="text-lg sm:text-xl font-medium">{label}</h3>
        </div>
        <span className="text-xs uppercase tracking-widest text-muted-brand">
          {implicit ? implicit[0].toUpperCase() + implicit.slice(1) : "Member"}
        </span>
      </div>

      <PersonalFieldsSection mKey={mKey} ins={ins} errors={errors} setIns={setIns} />
      <MedicalSection
        mKey={mKey}
        pe={ins.preExisting}
        errors={errors}
        setIns={setIns}
      />
      <LifestyleSection
        mKey={mKey}
        ls={ins.lifestyle}
        errors={errors}
        setIns={setIns}
      />
    </div>
  );
}
